export default "__VITE_ASSET__CkarxR_G__"